// import React, { useState } from 'react';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import { Link, useNavigate } from 'react-router-dom';
// import JoditEditor from 'jodit-react';
// import 'react-toastify/dist/ReactToastify.css';

// const AddBlog = ({ onCreate }) => {
//     const [formData, setFormData] = useState({ title: '', snippet: '', content: '', status: false, });
//     const [image, setImage] = useState(null);
//     const [isLoading, setIsLoading] = useState(false);
//     const navigate = useNavigate();

//     const handleChange = (e) => {
//         const { name, value, type, checked } = e.target;
//         setFormData((prev) => ({
//             ...prev,
//             [name]: type === 'checkbox' ? checked : value,
//         }));
//     };

//     const handleContentChange = (content) => {
//         setFormData((prev) => ({ ...prev, content, }));
//     };

//     const handleImageChange = (e) => {
//         setImage(e.target.files[0]);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         const data = new FormData();
//         data.append('title', formData.title);
//         data.append('snippet', formData.snippet);
//         data.append('content', formData.content);
//         data.append('status', formData.status);
//         if (image) data.append('image', image);

//         try {
//             await axios.post('https://api.sofiasurgicals.com/api/add-blog', data, {
//                 headers: { 'Content-Type': 'multipart/form-data' },
//             });
//             toast.success('Blog created successfully!');
//             if (onCreate) onCreate();
//             navigate('/all-blog');
//         } catch (error) {
//             console.error(error);
//             toast.error(error.response?.data?.message || 'Failed to create blog');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     return (
//         <>
//             <ToastContainer />
//             <div className="bread d-flex justify-between items-center mb-4">
//                 <h4>Create Blog</h4>
//                 <Link to="/all-blog" className="btn btn-secondary">
//                     <i className="fa-regular fa-circle-left"></i> Back
//                 </Link>
//             </div>

//             <form className="row g-3" onSubmit={handleSubmit}>
//                 <div className="col-md-4">
//                     <label className="form-label">Title</label>
//                     <input
//                         type="text"
//                         name="title"
//                         className="form-control"
//                         placeholder="Blog title"
//                         value={formData.title}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div>

//                 <div className="col-md-4">
//                     <label className="form-label">Snippet</label>
//                     <input
//                         type="text"
//                         name="snippet"
//                         className="form-control"
//                         placeholder="Short description"
//                         value={formData.snippet}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div>

//                 <div className="col-md-4">
//                     <label className="form-label">Image</label>
//                     <input
//                         type="file"
//                         name="image"
//                         className="form-control"
//                         onChange={handleImageChange}
//                     />
//                 </div>

//                 <div className="col-md-12">
//                     <label className="form-label">Content</label>
//                     <JoditEditor
//                         value={formData.content}
//                         onChange={handleContentChange}
//                         config={{ readonly: false }}
//                     />
//                 </div>

//                 {/* SEO */}

//                 <div className="col-md-4">
//                     <label className="form-label">Page Title (SEO)</label>
//                     <input
//                         type="text"
//                         name="title"
//                         className="form-control"
//                         placeholder="Page Title"
//                         value={formData?.seoTitle}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div><div className="col-md-4">
//                     <label className="form-label">URL Slug</label>
//                     <input
//                         type="text"
//                         name="title"
//                         className="form-control"
//                         placeholder="URL Slug"
//                         value={formData.urlSlug}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div><div className="col-md-4">
//                     <label className="form-label">Meta Discription</label>
//                     <input
//                         type="text"
//                         name="Meta Discription"
//                         className="form-control"
//                         placeholder="Blog title"
//                         value={formData.metaDiscription}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div>
//                 <div className="col-md-12">
//                     <label className="form-label">Meta Keywords</label>
//                     <JoditEditor
//                         value={formData.metaKeywords}
//                         onChange={handleContentChange}
//                         config={{ readonly: false }}
//                     />
//                 </div>
//                 <div className="col-md-6 form-check">
//                     <input
//                         type="checkbox"
//                         name="status"
//                         className="form-check-input"
//                         checked={formData.status}
//                         onChange={handleChange}
//                         id="statusCheckbox"
//                     />
//                     <label className="form-check-label" htmlFor="statusCheckbox">
//                         Active
//                     </label>
//                 </div>

//                 <div className="col-12 text-center">
//                     <button
//                         type="submit"
//                         className={`btn btn-primary ${isLoading ? 'disabled' : ''}`}
//                         disabled={isLoading}
//                     >
//                         {isLoading ? 'Please Wait...' : 'Create Blog'}
//                     </button>
//                 </div>
//             </form>
//         </>
//     );
// };

// export default AddBlog;


import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import 'react-toastify/dist/ReactToastify.css';

const slugify = (text) => {
    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
};

const AddBlog = ({ onCreate }) => {
    const [formData, setFormData] = useState({
        title: '',
        snippet: '',
        content: '',
        status: false,
        seoTitle: '',
        urlSlug: '',
        metaDescription: '',
        metaKeywords: '',
    });
    const [image, setImage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleContentChange = (content) => {
        setFormData((prev) => ({ ...prev, content }));
    };

    const handleMetaKeywordsChange = (metaKeywords) => {
        setFormData((prev) => ({ ...prev, metaKeywords }));
    };

    const handleImageChange = (e) => {
        setImage(e.target.files[0]);
    };

    // Auto-fill URL slug preview as user types title, unless they've typed a custom slug already
    const handleTitleChange = (e) => {
        const value = e.target.value;
        setFormData((prev) => ({
            ...prev,
            title: value,
            urlSlug: prev.urlSlug ? prev.urlSlug : slugify(value),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const data = new FormData();
        data.append('title', formData.title);
        data.append('snippet', formData.snippet);
        data.append('content', formData.content);
        data.append('status', formData.status);
        data.append('urlSlug', formData.urlSlug);
        data.append('seoTitle', formData.seoTitle);
        data.append('metaDescription', formData.metaDescription);
        data.append('metaKeywords', formData.metaKeywords);
        if (image) data.append('image', image);

        try {
            await axios.post('https://api.sofiasurgicals.com/api/add-blog', data, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            toast.success('Blog created successfully!');
            if (onCreate) onCreate();
            navigate('/all-blog');
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || 'Failed to create blog');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="bread d-flex justify-between items-center mb-4">
                <h4>Create Blog</h4>
                <Link to="/all-blog" className="btn btn-secondary">
                    <i className="fa-regular fa-circle-left"></i> Back
                </Link>
            </div>

            <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-md-4">
                    <label className="form-label">Title</label>
                    <input
                        type="text"
                        name="title"
                        className="form-control"
                        placeholder="Blog title"
                        value={formData.title}
                        onChange={handleTitleChange}
                        required
                    />
                </div>

                <div className="col-md-4">
                    <label className="form-label">Snippet</label>
                    <input
                        type="text"
                        name="snippet"
                        className="form-control"
                        placeholder="Short description"
                        value={formData.snippet}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="col-md-4">
                    <label className="form-label">Image</label>
                    <input
                        type="file"
                        name="image"
                        className="form-control"
                        onChange={handleImageChange}
                    />
                </div>

                <div className="col-md-12">
                    <label className="form-label">Content</label>
                    <JoditEditor
                        value={formData.content}
                        onChange={handleContentChange}
                        config={{ readonly: false }}
                    />
                </div>

                {/* SEO */}

                <div className="col-md-4">
                    <label className="form-label">Page Title (SEO)</label>
                    <input
                        type="text"
                        name="seoTitle"
                        className="form-control"
                        placeholder="Page Title"
                        value={formData.seoTitle}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-4">
                    <label className="form-label">URL Slug</label>
                    <input
                        type="text"
                        name="urlSlug"
                        className="form-control"
                        placeholder="url-slug-example"
                        value={formData.urlSlug}
                        onChange={handleChange}
                    />
                    <small className="text-muted">
                        Leave blank to auto-generate from title
                    </small>
                </div>

                <div className="col-md-4">
                    <label className="form-label">Meta Description</label>
                    <input
                        type="text"
                        name="metaDescription"
                        className="form-control"
                        placeholder="Meta description for search engines"
                        value={formData.metaDescription}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-12">
                    <label className="form-label">Meta Keywords</label>
                    <JoditEditor
                        value={formData.metaKeywords}
                        onChange={handleMetaKeywordsChange}
                        config={{ readonly: false }}
                    />
                </div>

                <div className="col-md-6 form-check">
                    <input
                        type="checkbox"
                        name="status"
                        className="form-check-input"
                        checked={formData.status}
                        onChange={handleChange}
                        id="statusCheckbox"
                    />
                    <label className="form-check-label" htmlFor="statusCheckbox">
                        Active
                    </label>
                </div>

                <div className="col-12 text-center">
                    <button
                        type="submit"
                        className={`btn btn-primary ${isLoading ? 'disabled' : ''}`}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Please Wait...' : 'Create Blog'}
                    </button>
                </div>
            </form>
        </>
    );
};

export default AddBlog;